"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapViewMode = exports.URL_PARAM_KEY_MAP_VIEW_MODE_ID = exports.URL_PARAM_KEY_PAGE_ID = exports.URL_PARAM_KEY_USER_ID = exports.URL_PARAM_KEY_PROJECT_ID_DEPRECATED = exports.URL_PARAM_KEY_CART_ITEM_ID = exports.URL_PARAM_KEY_PROJECT_ID = exports.URL_PARAM_KEY_PRODUCT_GROUP_ID = exports.URL_PARAM_KEY_UNIT_ID = exports.URL_PARAM_KEY_INTAKE_TYPE = void 0;
exports.URL_PARAM_KEY_INTAKE_TYPE = "intake-type";
exports.URL_PARAM_KEY_UNIT_ID = "unit";
exports.URL_PARAM_KEY_PRODUCT_GROUP_ID = "gid";
exports.URL_PARAM_KEY_PROJECT_ID = "pid";
exports.URL_PARAM_KEY_CART_ITEM_ID = "item";
exports.URL_PARAM_KEY_PROJECT_ID_DEPRECATED = "cid";
exports.URL_PARAM_KEY_USER_ID = "uid";
exports.URL_PARAM_KEY_PAGE_ID = "page";
exports.URL_PARAM_KEY_MAP_VIEW_MODE_ID = "view";
// MAP_VIEW_MODES
var MapViewMode;
(function (MapViewMode) {
    MapViewMode["COMPLETED_PROJECTS"] = "completed";
    MapViewMode["PROPERTY_MAP"] = "property";
})(MapViewMode = exports.MapViewMode || (exports.MapViewMode = {}));
//# sourceMappingURL=index.js.map